<template>
  <borrower-form />
</template>

<script>
import BorrowerForm from './Form'

export default {
  name: 'BorrowerEdit',
  components: { BorrowerForm },
  metaInfo () {
    return {
      title: this.$t('string.editBorrower'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
